import { AxiosResponse } from 'axios';
import { FetchResult, instance } from './config';
import { useInfiniteQuery } from '@tanstack/react-query';
import { IImageListItem } from '@types';

async function getCollectionImageList(
  params: {
    pageParam: number;
  },
  id?: number
): Promise<AxiosResponse<FetchResult<IImageListItem[]>>> {
  const response = await instance.get(`/collections/${id}?page=${params.pageParam}&take=21`);
  return response;
}

const useFetchCollectionImageList = (id?: number) => {
  const {
    data,
    fetchNextPage,
    fetchPreviousPage,
    hasNextPage,
    hasPreviousPage,
    isFetchingNextPage,
    isFetchingPreviousPage,
    promise,
    isLoading,
    isFetching,
    ...result
  } = useInfiniteQuery({
    queryKey: ['get', `/collections/${id}`],
    queryFn: ({ pageParam }) => getCollectionImageList({ pageParam }, id),
    initialPageParam: 1,
    getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => {
      if (lastPage.data.meta && lastPage.data.meta.hasNextPage) {
        return lastPage.data.meta.page + 1;
      } else {
        return null;
      }
    },
    retry: false,
    refetchOnWindowFocus: false,
    enabled: Boolean(id)
  });

  return {
    data,
    fetchNextPage,
    fetchPreviousPage,
    hasNextPage,
    hasPreviousPage,
    isFetchingNextPage,
    isFetchingPreviousPage,
    promise,
    isLoading,
    isFetching,
    ...result
  };
};

export default useFetchCollectionImageList;
